import { useMutation } from "@tanstack/react-query";
import { authService } from "services";
import { FormLogin } from "types";
import { useKey } from "./useKey";
import { useUser } from "./useUser";
import SnackbarUtils from "utils/SnackbarUtils";
import { useCommon } from "./useCommon";

export function useAuth() {

    const { setKeySite, removeKeySite } = useKey();
    const { setProfile, resetStorage } = useUser();
    const { setNullAllState } = useCommon()

    const loginMutation = useMutation({
        mutationFn: (formData: FormLogin) => authService.login(formData),
        onSuccess: async (res) => {
            console.log("🚀 ~ onSuccess: ~ res:", res)
            if (res.statusCode === 200) {
                SnackbarUtils.success(res?.message);
                const accessToken = res?.data?.accessToken;
                setKeySite({ accessToken })
                await getMe();
                return;
            }
            SnackbarUtils.error(res?.message ?? "Login failure!");
            return;
        },
        onError: (err) => {
            console.log("🚀 ~ useAuth ~ err:", err)
            console.error("Login failed", err);
        },
    });

    const getMe = async (isRedirect = true) => {
        const res = await authService.me();
        if (isRedirect) {
            setProfile(res.data);
            window.location.href = "/"
        }
    };

    const onLogout = async () => {
        setNullAllState();
        resetStorage();
        removeKeySite();
        await authService.logout();
        window.location.href = "/"
    };

    return {
        loginMutation,
        onLogout
    }
}
